export interface MetricChartChangeEvent {
    chartEvent: ChartEvent;
}


export enum ChartEvent {
    UpdateChartToZone
}